import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import { getBlogPage } from "../../model/blog";
import { commonErr } from "../common/errors";
import { formatTitleInUrl } from "../common/common";


export default class Blogs extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			blogPage: null,
			city: props.city,
		};
	}

	componentDidMount() {
		getBlogPage(0, this.state.city).then((resp) => {
			this.setState({
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
				blogs: resp.data.data,
			});
		});
	}

	render() {
		const { blogs } = this.state;
		if (!blogs || !blogs.blogs) {
			return null;
		} else {
			let blogArr = blogs.blogs;
			return (
				<>
					<div className="blog-section space sec">
						<div className="m-container">
							<h2>MIOTO Blog</h2>
							<div className="blog-container">
								<div className="blog-wrap-2-item">
									<Link className="blog-item" to={`/blog/${formatTitleInUrl(blogArr[0].title)}/${blogArr[0].id}`}>
										<div className="blog-item__img">
											<img loading="lazy" src={blogArr[0].thumb ? blogArr[0].thumb : defThumb2} alt="Mioto - Thuê xe tự lái" />
										</div>
										<div className="blog-item__content">
											<p className="time-text">{moment(blogArr[0].timeCreated).format("DD-MM-YYYY")}</p>
											<p className="name-text">{blogArr[0].title}</p>
										</div>
									</Link>
									{blogArr.length > 1 && (
										<Link className="blog-item" to={`/blog/${formatTitleInUrl(blogArr[1].title)}/${blogArr[1].id}`}>
											<div className="blog-item__img">
												<img loading="lazy" src={blogArr[1].thumb ? blogArr[1].thumb : undefined} alt="Mioto - Thuê xe tự lái" />
											</div>
											<div className="blog-item__content">
												<p className="time-text">{moment(blogArr[1].timeCreated).format("DD-MM-YYYY")}</p>
												<p className="name-text">{blogArr[1].title}</p>
											</div>
										</Link>
									)}
								</div>
								<div className="blog-wrap">
									{blogArr.length > 2 && (
										<Link
											className="blog-item"
											to={`/blog/${formatTitleInUrl(blogArr[2].title)}/${blogArr[2].id}`}
											style={{ display: "block" }}>
											<div className="blog-item__img">
												<img loading="lazy" src={blogArr[2].thumb ? blogArr[2].thumb : undefined} alt="Mioto - Thuê xe tự lái" />
											</div>
											<div className="blog-item__content">
												<p className="time-text">{moment(blogArr[2].timeCreated).format("DD-MM-YYYY")}</p>
												<p className="name-text">{blogArr[2].title}</p>
											</div>
										</Link>
									)}
								</div>
							</div>
							<div className="blog-swiper-container">
								<Swiper
									modules={[Pagination]}
									pagination={{
										el: ".pagi-blog",
										clickable: true,
										dynamicBullets: true,
									}}
									slidesPerView={1}
									spaceBetween={10}
									className="swiper-blog"
									breakpoints={{
										577: {
											slidesPerView: 1.4,
										},
									}}>
									{blogArr &&
										blogArr.map((blog) => (
											<SwiperSlide key={blog.id}>
												<Link to={`/blog/${formatTitleInUrl(blog.title)}/${blog.id}`}>
													<div className="fix-img">
														<img loading="lazy" src={blog.thumb ? blog.thumb : defThumb2} />
													</div>
													<div className="content">
														<p className="time-text">{moment(blog.timeCreated).format("DD-MM-YYYY")}</p>
														<p className="name-text">{blog.title}</p>
													</div>
												</Link>
											</SwiperSlide>
										))}
									<div className="swiper-pagination pagi-blog" />
								</Swiper>
							</div>
						</div>
					</div>
				</>
			);
		}
	}
}
